document.querySelectorAll('.tab-btn').forEach(btn => {
  btn.addEventListener('click', function () {
    const tab = this.dataset.tab;

    const panels = document.querySelectorAll('.tab-panel');
    const buttons = document.querySelectorAll('.tab-btn');

    buttons.forEach(b => b.classList.remove('active'));

    // trigger reflow (important for animation reset)
    panels.forEach(panel => {
      panel.classList.remove('active');
      panel.offsetHeight;
    });

    this.classList.add('active');

    panels.forEach(panel => {
      if (panel.dataset.tab === tab) {
        panel.classList.add('active');
      }
    });
  });
});